export * from './getSignListHeaders';

export const getSignageStatusItems = (): string[] => ([
  'New Signage',
  'Replace Existing Signage',
  'Alter Existing Signage',
  'Repair Existing Signage',
  'Additional Signage',
]);

export const getSignageTypeItems = (): string[] => ([
  'Single Faced',
  'V-shaped',
  'Double Sided',
  'Banner',
  'Wrap',
]);

export const getSignageSizeItems = (): string[] => (['4 x 8', '4 x 6', '4 x 4', 'Other:_____']);

export const getSignageInstallationTypeItems = (): string[] => (['Poles On Ground', 'Signs On Skids']);
